import { useTranslation } from 'react-i18next';
import {
  Separator,
  Typography,
  TYPOGRAPHY_SIZE,
  PLATFORM_THEME_COLORS,
  PageLayout,
  Loader,
} from '@thinknet-gmbh/platform-common-ui';

import { useRouteQuery } from 'src/common/helpers';
import { useGetLimitedEmployeeById } from 'src/hooks/employees/get-limited-employee-by-id.hook';

import { LimitedPersonalInfo } from './components/limited-personal-info';
import { LimitedWorkingConditions } from './components/limited-working-conditions';
import { MainWrapper } from './employee-details-limited-view.styles';

const EmployeeDetailsLimitedView = () => {
  const { t } = useTranslation('employee');

  const query = useRouteQuery();
  const _id: string = query.get('id') || '';

  const { employee, loading } = useGetLimitedEmployeeById(_id);

  if (loading) {
    return <Loader />;
  }

  return (
    <PageLayout pageTitle={t('labels.employee')}>
      <MainWrapper>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('labels.employeeProfile')}
        </Typography>
        <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
          {t('employeePersonalInfo.labels.personalInfo')}
        </Typography>
        <LimitedPersonalInfo personalInfo={employee} />
        <Separator />
        <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
          {t('labels.workingConditions')}
        </Typography>
        <LimitedWorkingConditions workingCondition={employee.activeWorkingCondition} />
      </MainWrapper>
    </PageLayout>
  );
};

export default EmployeeDetailsLimitedView;
